<template>
  <!-- 左侧导航栏 -->
  <div class="nav-menu-container">
    <el-menu
      :default-active="activeMenu"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b"
      :router="true"
      style="height: 100vh; width: 280px;">
      <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-user-solid"></i>
          <span>用户管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="/backstageAdmin">管理人员</el-menu-item>
          <el-menu-item index="/backstageUser">普通用户</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="/backstageNotice">
        <i class="el-icon-menu"></i>
        <span slot="title">公告</span>
      </el-menu-item>
      <el-submenu index="3">
        <template slot="title">
          <i class="el-icon-document"></i>
          <span>帖子</span>
        </template>
        <el-menu-item-group>
          <el-badge :value="12" :max="99" class="item">
            <el-menu-item index="/examineArticle">待审核帖子</el-menu-item>
          </el-badge>
          <el-menu-item index="/publishedArticle">已发布帖子</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="/goods">
        <i class="el-icon-shopping-bag-2"></i>
        <span slot="title">周边商品</span>
      </el-menu-item>
      <el-submenu index="5">
        <template slot="title">
          <i class="el-icon-setting"></i>
          <span>关于系统</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="5-1" @click="loginOut">退出登录</el-menu-item>
          <el-menu-item index="/userData">用户数据</el-menu-item>
          <el-menu-item index="/articleData">帖子数据</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-badge :value="15" class="item">
        <el-menu-item index="/handelInfo">
          <i class="el-icon-warning"></i>
          <span slot="title">举报信息</span>
        </el-menu-item>
      </el-badge>
    </el-menu>
  </div>
</template>

<script>
// import ExamineArticle from '@/pages/ExamineArticle.vue';
// import UserData from '@/pages/UserData.vue';


export default {
  name: 'NavMenu',
  data() {
    return {
      path: this.$route.path
    }
  },
  computed: {
    activeMenu() {
      return this.$route.path
    }
  },
  watch: {
    $route(to) {
      this.path = to.path
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log('handleOpen' + key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
    loginOut() {
      document.cookie = "isLogging=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/"
      document.cookie = "id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/"
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('role')
      this.$router.push('/')
    }
  }
};
</script>

<style scoped>
body, html {
  margin: 0;
  padding: 0;
  height: 100%;
}
.nav-menu-container {
  position: fixed; /* 固定定位 */
  left: 0; /* 靠左 */
  top: 0; /* 顶部对齐 */
  height: 100vh; /* 高度与屏幕一致 */
  width: 400px; /* 宽度为400px */
  overflow-y: auto; /* 如果内容超出高度，允许滚动 */
}

.el-menu {
  border-right: none; /* 去除默认的右边框 */
}
.item {
  margin-top: 10px;
  margin-right: 40px;
}
</style>